import styled from 'styled-components'

export const ResponsiveIframe = styled.iframe`
  display: block;
  width: 100%;
  margin: 12px auto 16px;
`
